export const practicalQuestionActionTypes = {
  TOGGLE_SHOW_TASK: "TOGGLE_SHOW_TASK",
  TOGGLE_TASK_DONE: "TOGGLE_TASK_DONE",
  TOGGLE_ALL_TASKS_DONE: "TOGGLE_ALL_TASKS_DONE",
  STORE_PRACTICAL_QUESTIONS: "STORE_PRACTICAL_QUESTIONS",
};
